import { useState } from "react"
import MainLayout from "../../components/layouts/MainLayout"
// import { EyeIcon, EyeSlashIcon } from '@heroicons/react/solid';
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { providerApi } from "../../api/providerApi";
import Swal from "sweetalert2";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { Auth } from "../../utils/Auth";


const CreateProviderView = () => {
  const navigate = useNavigate()
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        type_user: 'MECANICIEN',
        email: '',
        contact: '',
        password: '',
        speciality: '',
        experience: '',
        societeLibelle: '',
        societeAdresse: '',
        societeLieu: '',
        societePresentation: '',
        ville: '',
        adresse: '',
        contacts: [''],
    })
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const abortController = new AbortController()


    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible); // Alterner la visibilité du mot de passe
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleContactsChange = (e, index) => {
        const { value } = e.target;
        const newContacts = [...formData.contacts];
        newContacts[index] = value;
        setFormData({
          ...formData,
          contacts: newContacts,
        });
    };

    const handleAddContact = () => {
        setFormData({
          ...formData,
          contacts: [...formData.contacts, ''],
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
          // console.log(formData)

          const payload = {
            name:formData.name,
            lastname: formData.lastname,
            type_user: 'MECANICIEN',
            email: formData.email,
            contact: formData.contact,
            password: formData.password,
            speciality: formData.speciality,
            experience: formData.experience,
            libelle: formData.societeLibelle,
            adresse: formData.societeAdresse,
            lieu: formData.societeLieu,
            presentation: formData.societePresentation,
            ville: formData.ville,
            contacts: formData.contacts,
          }

          const res = await providerApi.storeProvider(JSON.stringify(payload),abortController.signal)

          // console.log(res)

          if (!res.success) {
            return Swal.fire({
              title:'Impossible d\'enregistrer',
              text:res.message,
              // timer:3000
            })
          }

          message.success('Mécanicien ajouté avec succès');
          setFormData({
            name: '',
            lastname: '',
            type_user: '',
            email: '',
            contact: '',
            password: '',
            speciality: '',
            experience: '',
            societeLibelle: '',
            societeAdresse: '',
            societeLieu: '',
            societePresentation: '',
            ville: '',
            adresse: '',
            contacts: [''],
          });
        } catch (error) {
          message.error('Une erreur est survenue lors de l\'ajout du mécanicien');
          const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                Auth.removeSessionToken()
                return navigate(`/login`)			
              });
        } finally {
          setLoading(false);
        }
    }

    return <MainLayout>
        <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Ajouter un Prestataire</h2>
      <form onSubmit={handleSubmit}>
        {/* Informations Utilisateur */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Nom <span className="text-red-600 text-sm italic">(Obligatoire)</span> </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Prénom <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Email <span className="text-red-600 text-sm italic">(Renseigner s'il a une adresse email)</span></label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Contact <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="contact"
            value={formData.contact}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Spécialité <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="speciality"
            value={formData.speciality}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Mot de passe <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <div className="relative">
            <input
              type={passwordVisible ? 'text' : 'password'} // Si passwordVisible est true, on affiche le mot de passe, sinon on le cache
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600"
            >
              {passwordVisible ? (
                <EyeInvisibleOutlined className="h-5 w-5" />
              ) : (
                <EyeOutlined className="h-5 w-5" />
              )}
            </button>
          </div>
        </div>

        {/* Informations Société */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Libellé Société <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="societeLibelle"
            value={formData.societeLibelle}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Adresse Société <span className="text-red-600 text-sm italic">(Optionnel)</span></label>
          <input
            type="text"
            name="societeAdresse"
            value={formData.societeAdresse}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Lieu <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="societeLieu"
            value={formData.societeLieu}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Informations Contact */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Contacts du Mécanicien <span className="text-red-600 text-sm italic">(Optionnel)</span></label>
          {formData.contacts.map((contact, index) => (
            <div key={index} className="flex items-center mb-2">
              <input
                type="text"
                value={contact}
                onChange={(e) => handleContactsChange(e, index)}
                placeholder="Numéro de téléphone"
                className="w-full px-4 py-2 border border-gray-300 rounded-md mr-2"
              />
              {formData.contacts.length > 1 && (
                <button
                  type="button"
                  onClick={() => {
                    const newContacts = [...formData.contacts];
                    newContacts.splice(index, 1);
                    setFormData({ ...formData, contacts: newContacts });
                  }}
                  className="text-red-500"
                >
                  Supprimer
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={handleAddContact}
            className="text-blue-500 mb-4"
          >
            Ajouter un contact
          </button>
        </div>

        {/* Description/presentation */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Description <span className="text-red-600 text-sm italic">(Optionnelcd)</span></label>         

          <textarea 
            name="societePresentation"
            value={formData.societePresentation}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          ></textarea>
        </div>

        {/* Soumission */}
        <div className="mt-6">
          <button
            type="submit"
            className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
            disabled={loading}
          >
            {loading ? 'Enregistrement...' : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
    </MainLayout>
}
export default CreateProviderView